"use client";

import React from "react";
import Header from "@/reusable_sections/Header";
import Footer from "@/reusable_sections/Footer";

// 導入組件
import Hero from "./sections/Hero";
import SearchFilter from "./sections/SearchFilter";
import Categories from "./sections/Categories";
import LatestArticles from "./sections/LatestArticles";
import TermsOverview from "./sections/TermsOverview";
import { PostsProvider } from "@/integrations/wordpress/WordPressPostsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
const KNOWLEDGE_TARGET_IDS = [24, 25, 27];
export default function KnowledgePage() {
  return <main className="min-h-screen bg-[#f3ede5]">
      <Header />
      <Hero />

      <PostsProvider wp_query={new WP_Query({
      post_type: "post",
      per_page: 12,
      cat: KNOWLEDGE_TARGET_IDS,
      orderby: "date",
      order: "desc"
    })}>
        {/*  優化：將底部的內距從 py-20 md:py-28 調整為 pt-20 md:pt-28 pb-0
            確保文章列表下方不會有多餘的 Padding 留白去推擠下方的滿版圖 */}
        <div className="w-full bg-[#f3ede5] pt-20 md:pt-28 pb-0 transition-colors duration-500">
          
          {/*  這裡保持 container 限制，讓搜尋、分類、文章整齊置中 */}
          <div className="container mx-auto px-6 flex flex-col gap-y-16 md:gap-y-24">
            
            {/* 搜尋欄區塊 */}
            <section className="max-w-3xl mx-auto w-full">
              <SearchFilter />
            </section>
            
            {/* 分類按鈕區塊 (Categories) */}
            <section>
              <Categories />
            </section>
            
            {/* 最新文章網格區塊 */}
            <section>
              <LatestArticles />
            </section>

          </div>
        </div>
      </PostsProvider>

      {/*  核心修正：把 TermsOverview 徹底解放！
          抽離到有寬度限制的 container 和有上下內距的 div 之外，直接貼在 Footer 上方。
          這樣一來，它就能發揮元件內部的 w-full，達到 100% 左右滿版，且下方絕不會再有任何間隙！ */}
      <TermsOverview />

      <Footer />
    </main>;
}